import { FC } from "react";
import { Button } from "@chakra-ui/react";

export const MainPagePaymentScheduleAddPaymentButton: FC = () => {
  return (
    <Button w="100%" mt="9px" colorScheme="brand">
      Внести платеж
    </Button>
  );
};
